import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-git-commit",
  "use": "icon-git-commit-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-git-commit\" id=\"icon-git-commit\"><circle cx=\"12\" cy=\"12\" r=\"4\" /><line x1=\"1.05\" y1=\"12\" x2=\"7\" y2=\"12\" /><line x1=\"17.01\" y1=\"12\" x2=\"22.96\" y2=\"12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol